import React from "react";
import "./HospitalFurniture.scss";
// import AOS from "aos";
import "aos/dist/aos.css";

const HospitalFurniture = () => {

  return (
    <div className="hospital-furniture">
      <div className="hospital-furniture__heading" data-aos="fade-up">
        Hi
      </div> 
    </div>
  );
};

export default HospitalFurniture;
